"use client";
import {
  setRouting,
  defaultValue,
  getSearchParams,
  isShowAllTabs,
  setRacesDetailLoading,
} from "@/app/utils/Common";
import { dateFormat, formattedDate, toDate, toDayJSWithDefault } from "@/app/utils/DayJS";
import {
  GET_RACE_CARD_LIST,
  GET_RACE_CARD_LIST_OLD,
  GET_RACE_INFO_LIST,
} from "@/app/utils/request/query";
import {
  getRaceCardList,
  getRaceCardColumns,
  getGearInfo,
  getRaceInfoList,
  getRaceReplayVideos,
} from "@/app/utils/request/requestList";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import RaceCardTable from "./RaceCardTable";
import { useMyContext } from "@/app/utils/MyContext";
import RaceSelector, { RaceSelectorData } from "@/app/ui/Common/RaceSelector";
import { LANGCODE_CT, LANGCODE_EN,  LANGTYPE_EN, useLanguage } from "@/app/utils/LanguageContext";
import {
  meetingStatus,
  raceStatus,
  runnerStatus,
} from "@/app/utils/constant/statusSet";
import _ from "lodash";
import { MenuTab, RaceNo } from "@/app/utils/class/common/base";
import { text_size } from "@/app/utils/MixinSize";
import { menuTabSet } from "@/app/utils/constant/menuTabSet";
import NoInformation from "@/app/ui/Common/NoInformation";
import { singlePools } from "@/app/utils/constant/odd";
import ExpertColumn from "./ExpertColumn";
import VideoPlayer from "@/app/ui/Common/VideoPlayer";
import { MultiVideoSource, VIDEOMODE_M, VIDEOMODE_S, VideoSource } from "@/app/utils/class/common/video";
import { VideoWAData } from "@/app/ui/Common/VideoPlayer/player";
import { useLoading } from "@/app/utils/LoadingContext";
import { resolve } from "path";
interface propType {
  setRacesDetailLoading: (loading: boolean) => void;
  isLoadingRacesDetail?: boolean;
  type: string;
}

const MContainer = styled.div`
  background: rgba(247, 247, 247, 1);
  border-radius: 0 0 4px 4px;
`;
const MTopContent = styled.div`
  width: 100%;
  background: white;
  padding: 12.79px 12px;
  display: flex;
  align-items: center;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
  p {
    ${text_size(13)}
    font-weight: 500;
    line-height: 17.71px;
    text-align: left;
  }
  img {
    max-height: 120px;
    min-height: 80px;
  }
`;
const Container = styled.div``;
const TopContent = styled.div`
  position: relative;
  width: 100%;
  background-color: #8B8B8B; 
`;
const AbandonedDiv = styled.div`
  border-radius: 4px;
  p {
    color: white;
    ${text_size(13)}
  }
  padding: 6px 8px;
  font-weight: 500;
  border-radius: inherit;
  text-align: center;
  max-height: 31px;
`;
const AbandonWrapper = styled.div`
  padding-top: 12px;
`;
const AbandonedDivM = styled.div`
  padding: 6.5px 0px;
  width: 100%;
  display: flex;
  justify-content: center;
  border-radius: 2px;
  background-color: #8B8B8B;
  font-weight: 500;
  min-width: 31px;
  text-align: center;
  p {
    color: white;
    ${text_size(13)}
  }
`;
const HeaderContent = styled('div')<{ $assetPrefix: string }>(({ $assetPrefix }) => `
  height: 162px;
  padding: 12px 12px;
  display: flex;
  width: 100%;
  background-image: url(${$assetPrefix}/raceCardBanner.svg);
  background-size: cover;
  & p {
    ${text_size(13)}
    font-weight: 500;
    line-height: 20px;
    text-align: left;
    color: #000000;
    margin-right: 20px;
  }
  & .trackMapImg {
    max-width: 280px;
    max-height: 138px;
  }
`);
const TableTab = styled.div`
  background-color: white;
  display: flex;
  align-items: center;
  padding: 12px;
  p {
    ${text_size(13)}
    font-weight: 500;
    line-height: 16px;
    text-align: left;
    color: rgba(51, 51, 51, 1);
  }
`;
const TableTabSplit = styled.div`
  margin: 0 12px;
  border: 1px solid rgba(180, 180, 180, 1);
  align-self: stretch;
`;
const TabBtn = styled.div<{ selected: boolean }>`
  border-radius: 30px;
  margin-right: 12px;
  padding: 6.5px 8px;
  cursor: pointer;
  box-shadow: 0px 2px 4px 0px rgba(212, 212, 212, 0.5);
  background-color: ${({ selected }) =>
    selected ? "rgba(23, 62, 150, 1)" : "rgba(226, 237, 246, 1)"};
  p {
    ${text_size(13)}
    font-weight: 500;
    text-align: center;
    color: ${({ selected }) => (selected ? "white" : "black")};
  }
`;
const RemarkWrapper = styled.div`
  border-radius: 0px 0px 4px 4px;
  padding: 12px;
  border-top: 1px solid rgba(204, 204, 204, 1);
  background-color: white;
`;
const RemarkWrapperM = styled.div`
  padding: 12px;
`;
const RemarkText = styled.p`
  word-break: break-all;
  ${text_size(13)}
  font-weight: 500;
`;
const ResetSortingBtn_PC = styled.div`
  margin-left: auto;
  padding-left: 12px;
  border-left: 1px solid var(--Stroke, #B4B4B4);
  cursor: pointer;
  p {
    border: 1px solid #003C84;
    height: 28px;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #003C84;
    padding: 0 8px;
  }
`;

const groupVideos = (videos: any, typeKey: string, keepOri?: boolean) => {6
  if (!(videos && Object.keys(videos).length > 0)) return [videos, null];
  const multiVideos = videos?.[`${typeKey}-multi`];
  const singleVideos = videos?.[typeKey];
  const latestDate = [singleVideos?.latestDate,multiVideos?.latestDate].filter(Boolean).sort((a, b) => b.localeCompare(a))?.[0];
  if (!latestDate) return [videos, null];

  const groupedDates = new Set([...Object.keys(multiVideos || {}).filter(k => k !== "latestDate"),...Object.keys(singleVideos || {}).filter(k => k !== "latestDate")]);
  const groupedKey = `${typeKey}-grouped`;
  const groupedObj = [...groupedDates].reduce((acc: any, date) => {
    acc[date] = {};
    const multiData = multiVideos?.[date];
    const singleData = singleVideos?.[date];
    const langCodes = new Set([...Object.keys(multiData || {}),...Object.keys(singleData || {}),]);
    [...langCodes].forEach((langCode) => {
      acc[date][langCode] = {};
       
      if (multiData?.[langCode]) acc[date][langCode][VIDEOMODE_M] = multiData[langCode];
      if (singleData?.[langCode]) acc[date][langCode][VIDEOMODE_S] = singleData[langCode];
    });
    return acc;
  },{});
  if (groupedObj && Object.keys(groupedObj).length > 0){
    videos[groupedKey] = {latestDate, ...groupedObj};
  }
  // Remove original types
  if (!keepOri) {    
    delete videos[typeKey];
    delete videos[`${typeKey}-multi`];
  }
  return [videos, groupedKey];
}

const RaceCard: React.FC<propType> = (props) => {
  const { isLoading, triggerLoading, completeLoading } = useLoading();
  const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
  const isLoadingPage = globalConfig.OTHERS.ENABLE_LOADING_CONTEXT ? isLoading('page') : props.isLoadingRacesDetail;
  const { b_cid } = getSearchParams(new URLSearchParams(window.location.search));
  const { state: lang } = useLanguage();
  const { t } = lang;
  const [selectTabPC, setSelectedTabPC] = useState("OverView");
  const [listData, setListData] = useState<any>([]);
  const [raceSelectorData, setRaceSelectorData] = useState<RaceSelectorData|undefined>();
  const [selectedRaceNo, setSelectedRaceNo] = useState<number>(
    myContextState.selectedRaceNo.valueOf()
  );
  const [curRaceData, setCurRaceData] = useState<any>({});
  const [curRaceStatus, setCurRaceStatus] = useState<any>("");
  const [tableList, setTableList] = useState<any>([]);
  const [reserveList, setReserveList] = useState<any>([]);
  const [mStatus, setMStatus] = useState<any>("");
  const [gearInfoData, setGearInfoData] = useState<any>([]);
  const [businessDate, setBusinessDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [remarkData, setRemarkData] = useState<any>([]);

  const [colunmConfigList, setcolunmConfigList] = useState<any>([]);

  const [detailTableList, setDetailTableList] = useState<any>([]);
  const [dynamicColumn, setDynamicColumn] = useState<any>({});
  const [isOffered, setIsOffered] = useState<any>(false);
  const [pmPoolsData, setPmPoolsData] = useState<any>([]);
  const [hasRaceCardInfo, setHasRaceCardInfo] = useState<boolean | null>(true);
  const [raceCountry, setRaceCountry] = useState<string>();
     
  const sortRef = useRef<any>(null);
  
  // video
  const [replaySources, setReplaySources] = useState([] as VideoSource[]|MultiVideoSource[]);
  const [WAData, setWAData] = useState<VideoWAData|undefined>(undefined);
  const [isShowReplay, setIsShowReplay] = useState(false);
  const [videoTitle, setvideoTitle] = useState(t("result_race_replay"));
  const TWO_A_SWITCH = globalConfig?.TwoASwitch;

  const selectDate = formattedDate(
    myContextState.selectedMeetingDate,
    "YYYY-MM-DD"
  );

  const meetingDate = formattedDate(
    myContextState.selectedMeetingDate,
    "YYYY-MM-DD"
  );
  const meetingVenueCode =
    myContextState.selectedMeetingVenueCode;

  const handleTrackmapClick = () => {
    const trackAnalysisMenuTab = new MenuTab(menuTabSet.TRACK_ANALYSIS);    
    setRacesDetailLoading(props.setRacesDetailLoading, menuTabSet.TRACK_ANALYSIS, true);
    triggerLoading('page', menuTabSet.TRACK_ANALYSIS);
    setRouting(`/${encodeURIComponent(trackAnalysisMenuTab.valueOf())}`, {b_cid: ''}, myContextState);
    myContextDispatch({
      type: "update",
      value: { menuTab: trackAnalysisMenuTab },
    });
  };

  const getHorseDataList = (runners: any) => {
    const reserveData = runners
      ?.map((item: any) => {
        if (
          item.status === runnerStatus.DRAFTSTANDBY ||
          item.status === runnerStatus.STANDBY ||
          item.status === runnerStatus.SCRATCHEDRESERVED
        ) {
          return {
            horseNo: Number(item.no),
            ...item,
          };
        }
      })
      ?.filter((item: any) => item !== undefined);
    const horseData = runners
      ?.map((item: any) => {
        if (
          item.status !== runnerStatus.DRAFTSTANDBY &&
          item.status !== runnerStatus.STANDBY &&
          item.status !== runnerStatus.SCRATCHEDRESERVED
        ) {
          return {
            horseNo: Number(item.no),
            ...item,
          };
        }
      })
      ?.filter((item: any) => item !== undefined);
    console.log("horseData------", horseData);
    if (horseData.length) {
      setHasRaceCardInfo(true);
    } else {
      setHasRaceCardInfo(false);
    }
    setTableList(_.orderBy(horseData, ["horseNo"], ["asc"]));
    setReserveList(_.orderBy(reserveData, ["horseNo"], ["asc"]));
  };
  useEffect(() => {
        const bizdate = formattedDate(myContextState.bizDate, "YYYY-MM-DD")
        setBusinessDate(bizdate);
        console.log("getBusinessDate error", bizdate)
        if (
          (bizdate && (new Date(selectDate) >= new Date(bizdate))) || 
          isShowAllTabs()
          ) {
          getRaceCardListData()
        } else {
          setLoading(false);
          setHasRaceCardInfo(false);
          setBusinessDate('bizdate_null');
          setRacesDetailLoading(props.setRacesDetailLoading)
          completeLoading('page');
        } 
  }, [myContextState.bizDate]);
  const getRaceSplitTime = (splitTime: any) => {
    let result = "-";
    let hasSplitTime = false;
    if (splitTime?.length) {
      let timeArr = [];
      timeArr = splitTime?.map((item: any) => {
        if (item.sectionTime) {
          hasSplitTime = true;
          return item.sectionTime;
        } else {
          return "-";
        }
      });
      result = timeArr.join(" ");
    }
    return hasSplitTime ? result : "-";
  };
  const getPosInRunning = (posInfo: any) => {
    let result = "-";
    let hasPos = false;
    if (posInfo?.length) {
      let posArr = [];
      posArr = posInfo?.map((item: any) => {
        if (item.ruPos !== -1) {
          hasPos = true;
          return item.ruPos;
        } else {
          return "-";
        }
      });
      result = posArr.join(" ");
    }
    return hasPos ? result : "-";
  };
  const getDynamicColumn = (list: any) => {
    const dynamicData = {
      sectionTime: false,
      finalTimeOfRace: false,
      sectionInfos: false,
      marginOrLBW: false,
      winOdds: false,
      med: false,
      comments: false,
    };
    list?.map((record: any) => {
      record?.horseFormRecord?.map((item: any) => {
        if (getRaceSplitTime(item.sectionTimeSplits) !== "-") {
          dynamicData.sectionTime = true;
        }
        if (item.finalTimeOfRace) {
          dynamicData.finalTimeOfRace = true;
        }
        if (getPosInRunning(item.sectionInfos) !== "-") {
          dynamicData.sectionInfos = true;
        }
        if (item.marginOrLBW?.code) {
          dynamicData.marginOrLBW = true;
        }
        if (item.winOdds) {
          dynamicData.winOdds = true;
        }
        if (lang.langType === LANGTYPE_EN) {
          if (item.med?.english) {
            dynamicData.med = true;
          }
          if (item.comments?.english) {
            dynamicData.comments = true;
          }
        } else {
          if (item.med?.chinese) {
            dynamicData.med = true;
          }
          if (item.comments?.english) {
            dynamicData.comments = true;
          }
        }
      });
    });
    setDynamicColumn(dynamicData);
  };

  const getRaceCardListData = () => {
    const currRaceNo = myContextState.selectedRaceNo.valueOf();
      setSelectedRaceNo(currRaceNo);
      setLoading(true);
      
      const basicProm = new Promise((resolve, reject) => {
        getRaceCardList(
          {
            date: meetingDate,
            venueCode: meetingVenueCode,
            type: "LIEF_TIME",  
            meetingDate: meetingDate.replaceAll("-", ""),
            raceNumber: `${currRaceNo}`,
            venCode: meetingVenueCode,
          },
          TWO_A_SWITCH ? GET_RACE_CARD_LIST : GET_RACE_CARD_LIST_OLD,
          "qids"
        )
          .then((res: any) => {
            const races = res.raceMeetingProfile?.[0]?.races ?? [];
            if (!races?.length) {
              setHasRaceCardInfo(false);
              resolve(undefined);
              return
            }
            const pool = res.raceMeetingProfile?.[0].pmPools;
            setIsOffered(
              pool?.filter((x: any) => x.leg.races[0] === currRaceNo)
                .length === 0
            );
            setPmPoolsData(pool);
            setMStatus(res.raceMeetingProfile?.[0].status);
            let newRaceNos = [] as number[];
            for (let i = 0; i < races?.length; i++) {
              newRaceNos[i] = races[i].no;
            }
            setRaceSelectorData({[meetingVenueCode]: {races: newRaceNos}});
            setListData(races);
            const currentRace = races.filter((x: any) => x.no === currRaceNo);
            console.log("race card runners", races, currRaceNo);
            getRenderRemarks(currentRace?.[0]?.remarks);
            setCurRaceData(currentRace?.[0]); 
            setRaceCountry(currentRace?.[0]?.countryCodeNm?.english);  
            setCurRaceStatus(currentRace?.[0]?.status);
            resolve({runners: currentRace?.[0]?.runners, resSimulcastHorse: res?.simulcastHorse || []});
          })
          .catch((e: any) => {
            console.log(e);
            setHasRaceCardInfo(false);
            resolve(undefined);
          });
      })

      const ruDetailProm = new Promise((resolve, reject) => {
        getRaceInfoList(
          {
            meetingDate: meetingDate.replaceAll("-", ""),
            raceNumber: `${currRaceNo}`,
            venCode: meetingVenueCode,
          },
          GET_RACE_INFO_LIST,
          "qids"
        )
          .then((res: any) => {
            setDetailTableList(res.simulcastHorse);
            getDynamicColumn(res.simulcastHorse);
            resolve(undefined);
          })
          .catch((e) => {
            console.log(e);
            resolve(undefined);
          });
      })

      const videoProm = new Promise((resolve, reject) => {
        getRaceReplayVideos(formattedDate(myContextState.selectedMeetingDate,"DD/MM/YYYY"),meetingVenueCode, `${currRaceNo}`)
          .then((res: any) => {
            // convert data to following structure with latest date info
            // `{
            //   "S1_1_1": {
            //       "sim-lr-multi": {
            //           "latestDate": "20240719",
            //           "20240719": {
            //               "zh-hk": "https://streaminghkjc-a.akamaihd.net/hdflash/sim-lr-multi/2024/20240720/s010101-20240719-20240720/chi/sim-lr-multi_20240720_s010101-20240719_chi.mp4",
            //               "en-us": "https://streaminghkjc-a.akamaihd.net/hdflash/sim-lr-multi/2024/20240720/s010101-20240719-2-20240720/eng/sim-lr-multi_20240720_s010101-20240719-2_eng.mp4"
            //           },
            //           "20240718": {
            //               "zh-hk": "https://streaminghkjc-a.akamaihd.net/hdflash/sim-lr-multi/2024/20240720/s010101-20240718-20240720/chi/sim-lr-multi_20240720_s010101-20240718_chi.mp4",
            //               "en-us": "https://streaminghkjc-a.akamaihd.net/hdflash/sim-lr-multi/2024/20240720/s010101-20240718-20240720/eng/sim-lr-multi_20240720_s010101-20240718_eng.mp4"
            //           }
            //       }
            //   }
            // }`
            
            const videoByRunnerKey = res?.raceReplayVideo?.reduce((acc:any, item:any) => {
              const { type, meetingDate, venue, race } = item;
              const prefix = venue;
              race.forEach((r:any) => {
                const key = `${prefix}_${r?.raceNo}_${r?.runnerNo}`;
                const sortedVideos = [...(r?.raceReplayURL || [])].sort((a:any, b:any) => b?.replayDate?.localeCompare(a?.replayDate));
                const latestDate = sortedVideos[0]?.replayDate;
                // Find or create type record
                let typeObj = sortedVideos?.reduce((vAcc:any, vItem:any) => {
                  const { lang, replayURL, replayDate } = vItem;
                  const vKey = lang.toLowerCase() === "chi" ? LANGCODE_CT : LANGCODE_EN;
                  if (vAcc[replayDate]){
                    vAcc[replayDate] = {...vAcc[replayDate], [vKey]: replayURL}
                  } else {
                    vAcc[replayDate] = {[vKey]: replayURL}
                  }
                  return vAcc;
                }, {});
                if (latestDate) {
                  // Find or create runner record
                  let r:any = {latestDate, ...typeObj};
                  if (acc[key]){
                    acc[key] = {...acc[key], [type]: r}
                  } else {
                    acc[key] = {[type]: r}
                  }
                };
              });
              return acc;
            }, {});
            console.log('videoByRunnerKey', videoByRunnerKey)
            resolve(videoByRunnerKey);
          })
          .catch((e) => {
            console.log(e);
            resolve(undefined);
          });
      })

      if (TWO_A_SWITCH) {
      Promise.all([basicProm, ruDetailProm, videoProm])
        .then((res: any[]) => {
          const [data,, videoByRunnerKey] = res;
          const {runners, resSimulcastHorse} = data;
          const _selectDate = formattedDate(
            myContextState.selectedMeetingDate,
            "YYYYMMDD"
          );
          const tempRunners = runners?.map((runner: any) => {
            let tempRes = resSimulcastHorse?.find(
              (sim: any) => sim.brandNumber === runner.id
            );
            if (tempRes) {
              const isScratched = [runnerStatus.SCRATCHED, runnerStatus.SCRATCHEDRESERVED].includes(runner.status);
              runner.performanceStats = tempRes.performanceStats;
              runner.earings = tempRes.earings;
            }
            let tempVideos = videoByRunnerKey?.[`${meetingVenueCode}_${currRaceNo}_${runner.no}`];
            if (tempVideos) {
              const [gpVideos, lastrunKey] = groupVideos(tempVideos, "sim-lr");
              tempVideos = gpVideos;
              if (tempVideos?.[lastrunKey]){
                const latestDate = tempVideos?.[lastrunKey]?.latestDate;
                const latestLastrun = latestDate ? tempVideos?.[lastrunKey]?.[latestDate]?.[lang.langCode] : undefined;
                runner.videoLatestLastrun = latestLastrun;
              }
              runner.videos = tempVideos;

              const latestDate_bt = tempVideos?.["sim-bt"]?.latestDate;
              const latestLastrun_bt = latestDate_bt ? tempVideos?.["sim-bt"]?.[latestDate_bt]?.[lang.langCode] : undefined;
              runner.barrierTrialLink = latestLastrun_bt;
            }
            return runner;
          });
          console.log(`RaceCard tempRunners`, tempRunners);
          getHorseDataList(tempRunners);
        })
        .finally(() => {
            setLoading(false);
            setRacesDetailLoading(props.setRacesDetailLoading)
            completeLoading('page');
        })
      } else {
        Promise.all([basicProm, ruDetailProm])
          .then((res: any[]) => {
            const [data,,] = res;
            const {runners, resSimulcastHorse} = data;
            const tempRunners = runners?.map((runner: any) => {
              let tempRes = resSimulcastHorse?.find(
                (sim: any) => sim.brandNumber === runner.id
              );
              if (tempRes) {
                const isScratched = [runnerStatus.SCRATCHED, runnerStatus.SCRATCHEDRESERVED].includes(runner.status);
                runner.performanceStats = tempRes.performanceStats;
                runner.earings = tempRes.earings;
                runner.videoReplayLink = isScratched ? "" : lang.langCode == 'en-us' ? tempRes?.horseFormRecord?.[0]?.videoReplayLink?.english
                : tempRes?.horseFormRecord?.[0]?.videoReplayLink?.chinese;
                return runner;
              }
              return runner;
            });
            getHorseDataList(tempRunners);
          })
          .finally(() => {
              setLoading(false);
              setRacesDetailLoading(props.setRacesDetailLoading)
              completeLoading('page');
          })
      }
  }
  useEffect(() => {
    if (!businessDate) return
    if (businessDate === 'bizdate_null') {
      setRacesDetailLoading(props.setRacesDetailLoading)
      completeLoading('page');
      return
    }
    if (new Date(selectDate) >= new Date(businessDate) ||
      isShowAllTabs()) {
      getRaceCardListData()
    }
  }, [myContextState.selectedRace]);

  useEffect(() => {
    getGearInfo(lang.langCode)
      .then((res: any) => {
        setGearInfoData(res?.item?.children);
      })
      .catch((e: any) => {
        console.log(e);
      });
 
    // getMeetingCountryAndHorseStatus(meetingDate, meetingVenueCode)
    //   .then((res: any) => {
    //      console.log("getMeetingCountry 1", res, res?.raceMeetingProfile[0]?.country[0]?.code)
    //      setMeetingCountry(res?.raceMeetingProfile[0]?.country[0]?.code)
    //   })
    //   .catch((e: any) => {
    //     console.log(e); 
    //   }); 

    getRaceCardColumns(lang.langCode)
      .then((res: any) => {
        const columns = res?.raceCardColumns?.children || [];
        if (columns?.length) {
          interface ClmConfig {
            id: string;
            btnText: string;
            columns: any;
            sortFieldList: any;
          }

          const clmConfigList: ClmConfig[] = [];
          for (let index = 0; index < columns.length; index++) {
            const item = columns[index];

            if (!item?.tabLabel?.value || !item?.columns?.targetItems.length)
              continue;

            const tempColumns = item?.columns?.targetItems?.map(
              (clmObj: any) => ({
                id: clmObj?.displayName?.split(" ")?.slice?.(1)?.join(""),
                label: clmObj?.Option_Name?.value,
              })
            );
            clmConfigList.push({
              id: `race-card-column-${index}-${Date.now()}`,
              btnText: item?.tabLabel?.value,
              columns: tempColumns,
              sortFieldList: tempColumns?.map((i: any) => i.id),
            });
          }
          setcolunmConfigList(clmConfigList);
          setSelectedTabPC(clmConfigList?.[0]?.id);
        }
      })
      .catch((e: any) => { });
  }, []);

  const handleSelectRace = (raceNo: number) => {
    if (raceNo != -1 && raceNo !== myContextState.selectedRaceNo.valueOf()) {
      setRacesDetailLoading(props.setRacesDetailLoading, myContextState.menuTab.toString(), true, true);
      triggerLoading('race', myContextState.menuTab.toString());
      setSelectedRaceNo(raceNo);
      myContextDispatch({
        type: "update",
        value: { selectedRaceNo: new RaceNo(raceNo) },
      });
    }
  };
  const getRaceInfoText = () => {
    const date = formattedDate(
      toDate(curRaceData?.postTime, "YYYY-MM-DDTHH:mm:ssZ"),
      dateFormat.display.fulldatetime
    );
    const raceClass =
      lang.langType === LANGTYPE_EN
        ? curRaceData?.raceClass_en
        : curRaceData?.raceClass_ch;
    const distance = curRaceData?.distance
      ? `${curRaceData?.distance}${lang.langType === LANGTYPE_EN ? "m" : "米"}`
      : "";
    const track =
      lang.langType === LANGTYPE_EN
        ? curRaceData?.raceTrack?.description_en
        : curRaceData?.raceTrack?.description_ch;
    const course =
      lang.langType === LANGTYPE_EN
        ? curRaceData?.raceCourse?.description_en
        : curRaceData?.raceCourse?.description_ch;
    const country =
      lang.langType === LANGTYPE_EN
        ? curRaceData?.country_en
        : curRaceData?.country_ch;
    const going =
      lang.langType === LANGTYPE_EN ? curRaceData?.go_en : curRaceData?.go_ch;

    const infoResult = `${raceClass ? `,${raceClass}` : ""}${distance ? `, ${distance}` : ""
      }${track ? `, ${track}` : ""}${course ? `, ${course}` : ""}${country ? `, ${country}` : ""
      }${going ? `, ${going}` : ""}`.replace(/,/, "");
    console.log("race_info", infoResult);
    return (
      <>
        <p>{`${date ? `${date},` : ""}`}</p>
        <p>{infoResult}</p>
      </>
    );
  };
  const getRenderRemarks = (remarks: any) => {
    const mergedRemarks = remarks?.reduce((acc: any, remark: any) => {
      const existing = acc.find((r: any) => r.seqNo === remark.seqNo);
      if (existing) {
        if (remark.name_en) existing.name_en = remark.name_en;
        if (remark.name_ch) existing.name_ch = remark.name_ch;
      } else {
        acc.push({
          seqNo: remark.seqNo,
          name_en: remark.name_en,
          name_ch: remark.name_ch,
        });
      }
      return acc;
    }, []);
    const renderRemark = _.orderBy(mergedRemarks, ["seqNo"], ["asc"]).filter(
      (item: any) => item.seqNo > 6
    );
    console.log("mergedRemarks", renderRemark);
    setRemarkData(renderRemark);
  };
  useEffect(() => {
    if (props.type == "mobile") {
      myContextDispatch({
        type: "update",
        value: { 
          renderMobileRaceCardStatus: () => renderStatus("mobile"),
        }
      });
    }
  }, [pmPoolsData])
  const isRaceVoid = () => {
    console.log("pmPoolsData", pmPoolsData);
    const pools = singlePools;
    const pmPoolsStatus = pmPoolsData
      ?.filter(
        (item: any) =>
          item.leg.races[0] === selectedRaceNo && pools.includes(item.oddsType)
      )
      .map((i: any) => i.status);

    const isSinglePoolrefunded =
      pmPoolsStatus?.length > 0 &&
      pmPoolsStatus?.filter((x: any) => x.toUpperCase().indexOf("REFUND") >= 0)
        ?.length === pmPoolsStatus.length;
    return (
      curRaceStatus === raceStatus.VOIDED ||
      mStatus === meetingStatus.ABANDON ||
      (mStatus === meetingStatus.ABANDON_PARTIAL &&
        curRaceStatus !== raceStatus.RESULT) ||
      (isSinglePoolrefunded && mStatus !== meetingStatus.ABANDON)
    );
  };
  const renderStatus = (type: any) => {
    let result = "";
    if (curRaceStatus === raceStatus.ABANDONED && isOffered) {
      result = t("result_not_offered_abandoned");
    } else if (isRaceVoid() && isOffered) {
      result = t("result_not_offered_void");
    } else {
      if (curRaceStatus === raceStatus.ABANDONED) {
        result = t("race_abandon");
      } else if (isRaceVoid()) {
        result = t("meeting_void_msg");
      }
      if (isOffered) {
        result = t("meeting_not_offered");
      }
    }
    if (type === "pc") {
      return result ? (
        <AbandonedDiv>
          <p id="raceCard_race_status_pc">{result}</p>
        </AbandonedDiv>
      ) : null;
    } else {
      return result ? (
        <AbandonWrapper>
          <AbandonedDivM>
            <p id="raceCard_race_status_mobile">{result}</p>
          </AbandonedDivM>
        </AbandonWrapper>
      ) : null;
    }
  };

  const renderTabBtnList = () => {
    return (
      <>
        {colunmConfigList.map((i: any, idx: number) => {
          return (
            <TabBtn
              id={`raceCard_columnBtn_${idx}`}
              key={idx}
              onClick={() => handleClickTabBtnPC(i.id)}
              selected={selectTabPC === i.id}
            >
              <p>{i.btnText}</p>
            </TabBtn>
          );
        })}

        <ResetSortingBtn_PC
          onClick={() => sortRef?.current?.resetDefaultSort?.()}>
          <p>{t("sorting_Btn_PC")}
          </p>
        </ResetSortingBtn_PC>
      </>
    );
  };
  const handleClickTabBtnPC = (type: string) => {
    setSelectedTabPC(type);
  };
  if (isLoadingPage) return null

  if (!hasRaceCardInfo) {
    return <NoInformation />
  }

  //video player part - start
  const openVideoPlayer = (videoSrc: VideoSource[]|MultiVideoSource[], waData: VideoWAData) => {
    if (!videoSrc) return;
    // adobeAnalysis //6
    setWAData(waData);
    setReplaySources(videoSrc);
    setIsShowReplay(true);
  }

  const handleClose = () => {
      setIsShowReplay(false);
      setWAData(undefined);
      setReplaySources([]);
  }
  //video player part - end

  return (
  <>
  {
      props.type === "pc" ? (
          <Container>
            <TopContent>
              {renderStatus("pc")}
              {/* <RaceSelector
                type="pc"
                selectedVenueCode={myContextState.selectedMeeting?.meetingVenueCode || ""}
                selectedRaceNo={selectedRaceNo}
                handleSelectRace={handleSelectRace}
                data={raceSelectorData}
              ></RaceSelector>
              <HeaderContent $assetPrefix={myContextState.assetPrefix}>
                <div id="race_info_pc">{getRaceInfoText()}</div>
                <div>
                  <img
                    className={`trackMapImg clickable${myContextState.selectedRace?.trackMap ? '' : ' hidden'}`}
                    alt={defaultValue(
                      myContextState.selectedRace?.trackMap?.alt,
                      ""
                    )}
                    src={defaultValue(
                      myContextState.selectedRace?.trackMap?.src,
                      ""
                    )}
                    onClick={() => handleTrackmapClick()}
                  />
                </div>
              </HeaderContent> */}
            </TopContent>
            <TableTab>
              <p id="race_card_title">{t("race_card")}</p>
              <TableTabSplit />
              {renderTabBtnList()}
            </TableTab>
            <RaceCardTable
              ref={sortRef}
              hasOrderBy={true}
              id="race_card_table1"
              raceNo={selectedRaceNo}
              tableData={tableList}
              gearData={gearInfoData}
              selectTabPC={selectTabPC}
              colunmConfigList={colunmConfigList}
              propDetail={detailTableList}
              propDynamicColumn={dynamicColumn}
              raceCountry={raceCountry}
              handleOpenVideoPlayer={openVideoPlayer}
              isSticky
              setvideoTitle={setvideoTitle}
            />

            {reserveList?.length ? (
              <div style={{ marginTop: "30px" }}>
                <TableTab>
                  <p id="race_card_reserve_title">{t("race_card_reserve")}</p>
                  <TableTabSplit />
                </TableTab>
                <RaceCardTable
                  id="race_card_table2"
                  hasOrderBy={false}
                  isReserve
                  raceNo={selectedRaceNo}
                  tableData={reserveList}
                  gearData={gearInfoData}
                  selectTabPC={selectTabPC}
                  colunmConfigList={colunmConfigList}
                  propDetail={detailTableList}
                  propDynamicColumn={dynamicColumn}
                  raceCountry={raceCountry} 
                  handleOpenVideoPlayer={openVideoPlayer}
                  isSticky
                  setvideoTitle={setvideoTitle}
                />
              </div>
            ) : null}
            <RemarkWrapper id="race_card_remarks_pc">
              {remarkData?.map((remark: any, idx: number) => (
                <RemarkText id={`race_card_remark_pc_${idx}`} key={idx}>
                  {lang.langType === LANGTYPE_EN ? remark?.name_en : remark?.name_ch}
                </RemarkText>
              ))}
              {lang.langType === LANGTYPE_EN ? (
                <RemarkText id="race_card_remark_horseType_pc">
                  C=Colt; H=Horse; F=Filly; M=Mare; G=Gelding; R=Rig
                </RemarkText>
              ) : null}
            </RemarkWrapper>

             <ExpertColumn hasRaceCardInfo={hasRaceCardInfo} type={props.type} setRacesDetailLoading={props?.setRacesDetailLoading} />
          </Container>
        ) : (
        <MContainer>
          {/* {renderStatus("mobile")} */}
          {/* <MTopContent>
            <div id="race_info_mobile">{getRaceInfoText()}</div>
            <img
              className={`trackMapImg clickable${myContextState.selectedRace?.trackMap ? '' : ' hidden'}`}
              alt={defaultValue(myContextState.selectedRace?.trackMap?.alt, "")}
              src={defaultValue(myContextState.selectedRace?.trackMap?.src, "")}
              onClick={() => handleTrackmapClick()}
            />
          </MTopContent>*/}
          <RaceCardTable
              hasOrderBy={true}
              id="race_card_mobile_table1"
              raceNo={selectedRaceNo}
              tableData={tableList}
              gearData={gearInfoData}
              propDetail={detailTableList}
              propDynamicColumn={dynamicColumn}
              raceCountry={raceCountry}
              handleOpenVideoPlayer={openVideoPlayer}
              isMobile
              setvideoTitle={setvideoTitle}
            /> 
          {reserveList?.length ? (
            <RaceCardTable
              id="race_card_reserve_table"
              hasOrderBy={false}
              isReserve
              raceNo={selectedRaceNo}
              tableData={reserveList}
              gearData={gearInfoData}
              propDetail={detailTableList}
              propDynamicColumn={dynamicColumn}
              raceCountry={raceCountry}
              handleOpenVideoPlayer={openVideoPlayer}
              isMobile
              setvideoTitle={setvideoTitle}
            />
          ) : null}

          <RemarkWrapperM id="race_card_remarks_mobile">
            {remarkData?.map((remark: any, idx: number) => (
              <RemarkText id={`race_card_remark_mobile_${idx}`} key={idx}>
                {lang.langType === LANGTYPE_EN ? remark?.name_en : remark?.name_ch}
              </RemarkText>
            ))}
            {lang.langType === LANGTYPE_EN ? (
              <RemarkText id="race_card_remark_horseType_mobile">
                C=Colt; H=Horse; F=Filly; M=Mare; G=Gelding; R=Rig
              </RemarkText>
            ) : null}
          </RemarkWrapperM>

          <ExpertColumn hasRaceCardInfo={hasRaceCardInfo} type={props.type}setRacesDetailLoading={props?.setRacesDetailLoading} />
        </MContainer>
      ) 
    }
    <VideoPlayer title={videoTitle} WAData={WAData} sources={replaySources} open={isShowReplay} isMobile={props.type == "mobile"} handleClose={handleClose} width={props.type == "mobile"?undefined:'60%'} height={props.type == "mobile"?undefined:'60%'} showCurrentTooltip showHoveredTooltip autoPlay />
  </>);
};
export default RaceCard;
